import { combineReducers } from "@reduxjs/toolkit";

import authReducer from "../Slices/authSlice";
// import cartReducer from "../slices/cartSlice";
// import courseReducer from "../slices/courseSlice";
import profileReducer from "../Slices/profileSlice";
// import viewCourseReducer from "../slices/viewCourseSlice";
// import categoryReducer from "../slices/categorySlice"; // Add this import

const rootReducer = combineReducers({
  auth: authReducer,
  profile: profileReducer,
//   course: courseReducer,
//   cart: cartReducer,
//   viewCourse: viewCourseReducer,
//   category: categoryReducer, // Add this line
});

export default rootReducer;
